// ------------------------------------------
// 施工事例のカルーセル
// ------------------------------------------
class WorksSlider {
  constructor(el, opt) {
    this.items = document.querySelectorAll('.' + el);
    if (this.items.length > 0) {
      this.duration = 1.2;
      this.dragThreshold = 6;
      // 少し動かしただけで隣へ切り替える距離と、素早く払ったときの距離・時間(Swiperの短いスワイプ相当)
      this.swipeDistance = 20;
      this.flickDistance = 8;
      this.flickTime = 300;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.sliders = Array.from(this.items).map((item) => this.setup(item));
      this.event();
    }
  }

  setup(item) {
    const s = {
      view: item.querySelector('.js-works-view'),
      track: item.querySelector('.js-works-track'),
      link: item.querySelector('.js-works-link'),
      dots: item.querySelectorAll('.js-works-dots'),
      originals: [],
      lefts: [],
      setWidth: 0,
      shift: 0,
      min: 0,
      max: 0,
      x: 0,
      index: 0,
      active: null,
      move: null,
      isMoving: false,
      isHover: false,
      hoverSlide: null,
      mouse: { x: 0, y: 0 },
      drag: null,
      isDragged: false,
    };
    s.originals = Array.from(s.track.children);

    this.bindDrag(s);
    this.bindClick(s);
    this.bindHover(s);
    this.bindDots(s);
    return s;
  }

  event() {
    this.build();

    let timer;
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(() => this.build(), 200);
    });
  }

  // ------------------------------
  // 無限ループ用の複製
  // ------------------------------
  build() {
    this.sliders.forEach((s) => {
      s.track.querySelectorAll('.is-clone').forEach((clone) => clone.remove());

      const first = s.originals[0];
      const last = s.originals[s.originals.length - 1];
      const gap = parseFloat(getComputedStyle(s.track).columnGap) || 0;
      const originLeft = first.offsetLeft;
      s.setWidth = last.offsetLeft + last.offsetWidth + gap - originLeft;
      s.lefts = s.originals.map((slide) => slide.offsetLeft - originLeft);
      s.shift = 0;
      if (!s.setWidth) return;

      const makeClone = (slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.add('is-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('img').forEach((img) => {
          img.loading = 'eager';
        });
        return clone;
      };

      // ホバー中は1周戻す処理をしないので、その間に何周かドラッグできるよう多めに複製する
      const copies = Math.ceil(s.view.clientWidth / s.setWidth) + 3;
      for (let i = 0; i < copies; i++) {
        s.originals.forEach((slide) => s.track.appendChild(makeClone(slide)));
      }
      for (let i = 0; i < copies; i++) {
        for (let j = s.originals.length - 1; j >= 0; j -= 1) {
          s.track.insertBefore(makeClone(s.originals[j]), s.track.firstChild);
        }
      }

      s.shift = first.offsetLeft - originLeft;
      s.min = s.view.clientWidth - copies * s.setWidth;
      s.max = (copies - 1) * s.setWidth;

      this.jumpTo(s, s.index);
    });
  }

  // ------------------------------
  // ドラッグ(スマホはスワイプ)
  // ------------------------------
  bindDrag(s) {
    s.view.addEventListener('pointerdown', (e) => {
      if (!e.isPrimary || e.button !== 0) return;

      if (s.move) s.move.kill();
      s.isMoving = false;
      s.drag = { pointerId: e.pointerId, startX: e.clientX, startPos: s.x, startIndex: this.nearest(s), startTime: Date.now() };
      s.isDragged = false;
    });

    // 写真の外までドラッグしても追えるように、動きと離したときは window で受け取る
    const dragMove = (e) => {
      if (!s.drag || e.pointerId !== s.drag.pointerId) return;

      const dx = e.clientX - s.drag.startX;
      if (!s.isDragged && Math.abs(dx) > this.dragThreshold) {
        s.isDragged = true;
        s.view.classList.add('is-dragging');
      }

      if (s.isDragged) {
        s.x = s.drag.startPos + dx;
        this.keepInRange(s);
        this.render(s);
      }
    };
    window.addEventListener('pointermove', dragMove);

    const dragEnd = (e) => {
      if (!s.drag || e.pointerId !== s.drag.pointerId) return;

      if (e.type === 'pointerup') dragMove(e);
      const { startPos, startIndex, startTime } = s.drag;
      s.drag = null;
      s.view.classList.remove('is-dragging');

      if (s.isDragged) {
        const dx = s.x - startPos;
        const isFlick = Date.now() - startTime < this.flickTime && Math.abs(dx) >= this.flickDistance;
        if (Math.abs(dx) >= this.swipeDistance || isFlick) {
          const forward = dx < 0;
          const count = s.lefts.length;
          this.goTo(s, (startIndex + (forward ? 1 : -1) + count) % count, forward);
        } else {
          this.goTo(s, this.nearest(s));
        }
      }
    };
    window.addEventListener('pointerup', dragEnd);
    window.addEventListener('pointercancel', dragEnd);

    // リンクをつかむブラウザ標準のドラッグが始まると、スライドが途中で止まるため
    s.link.addEventListener('dragstart', (e) => e.preventDefault());
  }

  // ------------------------------
  // ドラッグした直後はページを開かない
  // ------------------------------
  bindClick(s) {
    s.link.addEventListener('click', (e) => {
      if (s.isDragged) e.preventDefault();
    });
  }

  // ------------------------------
  // ホバー中の拡大
  // ------------------------------
  bindHover(s) {
    const enter = (e) => {
      if (e.pointerType !== 'mouse') return;
      s.isHover = true;
      s.mouse = { x: e.clientX, y: e.clientY };
      this.updateHover(s);
    };
    s.view.addEventListener('pointerenter', enter);
    s.view.addEventListener('pointermove', enter);

    s.view.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      s.isHover = false;
      this.updateHover(s);
    });
  }

  // CSSの :hover はマウスを止めたまま写真が動くと数秒切り替わらないため、写真が動くたびに判定し直す
  updateHover(s) {
    let slide = null;
    if (s.isHover) {
      slide = document.elementFromPoint(s.mouse.x, s.mouse.y);
      while (slide && slide.parentElement !== s.track) slide = slide.parentElement;
    }
    if (slide === s.hoverSlide) return;

    if (s.hoverSlide) s.hoverSlide.classList.remove('is-hover');
    if (slide) slide.classList.add('is-hover');
    s.hoverSlide = slide;
  }

  // ------------------------------
  // ドットで移動
  // ------------------------------
  bindDots(s) {
    s.dots.forEach((group) => {
      group.querySelectorAll('.js-works-dot').forEach((dot, i) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goTo(s, i);
        });
      });
    });
  }

  // ------------------------------
  // 位置の計算
  // ------------------------------
  // 1周ずれた同じ見た目の位置へ戻す
  // マウスの下の画像が複製と入れ替わり、ホバーの拡大が途切れるので、ホバーしていない自動送りの前だけで行う
  normalize(s, x) {
    if (!s.setWidth) return x;
    let next = x % s.setWidth;
    if (next > 0) next -= s.setWidth;
    return next;
  }

  keepInRange(s) {
    let offset = 0;
    if (s.x > s.max) offset = -s.setWidth;
    if (s.x < s.min) offset = s.setWidth;
    if (!offset) return;

    s.x += offset;
    if (s.drag) s.drag.startPos += offset;
  }

  targetOf(s, index, forward) {
    const target = -s.lefts[index];

    if (forward) return target > s.x ? target - s.setWidth : target;

    return target + Math.round((s.x - target) / s.setWidth) * s.setWidth;
  }

  nearest(s) {
    const x = this.normalize(s, s.x);
    let index = 0;
    let min = Infinity;
    s.lefts.forEach((left, i) => {
      [-left, -left - s.setWidth, -left + s.setWidth].forEach((pos) => {
        const diff = Math.abs(pos - x);
        if (diff < min) {
          min = diff;
          index = i;
        }
      });
    });
    return index;
  }

  // ------------------------------
  // 移動
  // ------------------------------
  jumpTo(s, index) {
    if (!s.setWidth) return;
    s.index = index;
    s.x = -s.lefts[index];
    this.render(s);
    this.updateDots(s);
  }

  goTo(s, index, forward) {
    if (!s.setWidth || typeof gsap === 'undefined') {
      this.jumpTo(s, index);
      return;
    }
    if (s.move) s.move.kill();

    const to = this.targetOf(s, index, forward);

    if (to === s.x) {
      s.index = index;
      this.updateDots(s);
      return;
    }

    s.isMoving = true;
    s.move = gsap.to(s, {
      x: to,
      duration: this.reduced ? 0 : this.duration,
      ease: 'power2.inOut',
      onUpdate: () => {
        this.render(s);
        this.updateDots(s);
      },
      onComplete: () => {
        s.index = index;
        s.isMoving = false;
        this.render(s);
        this.updateDots(s);
      },
    });
  }

  render(s) {
    const dpr = window.devicePixelRatio || 1;
    const x = s.x - s.shift;
    s.track.style.transform = `translate3d(${Math.round(x * dpr) / dpr}px, 0, 0)`;
    this.updateHover(s);
  }

  // ------------------------------
  // ドット
  // ------------------------------
  updateDots(s) {
    const index = this.nearest(s);
    if (index === s.active) return;

    s.active = index;
    s.dots.forEach((group) => {
      group.querySelectorAll('.js-works-dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    });
  }
}
